import { FormikHelpers } from 'formik';
import { ICity } from './types';

export enum EMapsActionType {
  GET_PREDICTIONS = 'GET_PREDICTIONS',
  GET_CONVERTED_PLACE_ID = 'GET_CONVERTED_PLACE_ID',
}

export interface IGetMapsAction {
  type: EMapsActionType.GET_PREDICTIONS;
  payload: {
    text: string;
    formikActions: FormikHelpers<{ cities: ICity[] }>;
  };
}

export const getMapsAction = (
  text: string,
  formikActions: FormikHelpers<any>
): IGetMapsAction => ({
  type: EMapsActionType.GET_PREDICTIONS,
  payload: {
    text,
    formikActions,
  },
});

export interface IGetAffinyPlaceIdAction {
  type: EMapsActionType.GET_CONVERTED_PLACE_ID;
  payload: { item: ICity; formikActions: FormikHelpers<any> };
}

export const getAffinyPlaceIdAction = (
  item: ICity,
  formikActions: FormikHelpers<any>
): IGetAffinyPlaceIdAction => ({
  type: EMapsActionType.GET_CONVERTED_PLACE_ID,
  payload: { item, formikActions },
});

export type IMapsAction = IGetMapsAction | IGetAffinyPlaceIdAction;
